import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { TEAM } from "../lib/data";

export default function Team() {
  return (
    <>
      <Seo title="Meet the Team" description="Meet the physiotherapists at Arena Movement Physiotherapy in Melbourne: experienced, evidence-based and movement-focused clinicians." path="/team" />
      <PageHeader
        eyebrow="Meet the Team"
        title="The people behind your recovery"
        subtitle="Experienced, friendly physiotherapists committed to evidence-based, movement-first care."
      />

      <section className="py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 space-y-16">
          {TEAM.map((m, i) => (
            <Reveal key={m.slug} delay={i * 0.05}>
              <div className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`team-member-${m.slug}`}>
                <div className="overflow-hidden rounded-[2rem] group">
                  <img
                    src={m.image}
                    alt={m.name}
                    style={{
                      objectPosition: m.imgPos || "center",
                      transform: `scale(${m.zoom || 1})`,
                      transformOrigin: m.imgPos || "center",
                    }}
                    className="w-full h-[460px] object-cover transition-transform duration-700"
                  />
                </div>
                <div>
                  <span className="text-xs font-bold tracking-[0.2em] uppercase text-navy">{m.role}</span>
                  <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-text-dark tracking-tight">{m.name}</h2>
                  <div className="mt-3 inline-flex items-center gap-2 text-text-muted">
                    <GraduationCap className="h-4 w-4 text-navy" /> {m.credentials}
                  </div>
                  <p className="mt-5 text-lg text-text-muted leading-relaxed">{m.bio}</p>
                  <div className="mt-6 flex flex-wrap gap-2">
                    {m.specialties.map((s) => (
                      <span key={s} className="rounded-full bg-navy/5 text-navy px-4 py-1.5 text-sm font-medium">{s}</span>
                    ))}
                  </div>
                  <Link to="/book" className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 font-semibold text-white transition-all hover:-translate-y-0.5" data-testid={`book-with-${m.slug}`}>
                    Book with {m.name.split(" ")[0]} <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
